// Copyright (c) 2026 DMG L&D, LLC. All rights reserved.
// Proprietary and confidential. See LICENSE for terms.

/**
 * Minify JSON — remove all whitespace, produce the smallest valid JSON.
 *
 * Input: UTF-8 bytes of a JSON string (pretty or already minified).
 * Output: UTF-8 bytes of the minified JSON.
 */

import type { Bytes } from '../types.ts';

export async function jsonMinify(input: Bytes): Promise<Bytes> {
  if (!(input instanceof Uint8Array)) {
    throw new Error('json.minify: input must be a Uint8Array');
  }

  const str = new TextDecoder().decode(input);

  let parsed: unknown;
  try {
    parsed = JSON.parse(str);
  } catch {
    throw new Error('json.minify: input is not valid JSON');
  }

  const output = JSON.stringify(parsed);
  return new TextEncoder().encode(output);
}
